"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ITC = exports.AVAILABLE_FOR_GRANULAR_ITC = void 0;
const AVAILABLE_FOR_GRANULAR_ITC = exports.AVAILABLE_FOR_GRANULAR_ITC = ['dpp_absol1', 'mya_dom_srch', 'dlp_cheapdomain_godaddy_b'];
const ITC = exports.ITC = {
  Default: AVAILABLE_FOR_GRANULAR_ITC[0],
  Bundle: 'dpp_absol_reoffer5',
  ...Object.assign({}, ...AVAILABLE_FOR_GRANULAR_ITC.map(itc => ({
    [itc]: {
      Favorites: `${itc}.favorites`,
      History: `${itc}.history`,
      NameBuilder: `${itc}.namebuilder`,
      ConversationalSearch: `${itc}.ai_search`,
      Alternate: {
        Premium: `${itc}.aftermarket_alternate`,
        RegPremium: `${itc}.regpremium_alternate`,
        Auction: `${itc}.auction_alternate`,
        Taken: `${itc}.unavailable_alternate`,
        Available: `${itc}.primary_alternate`
      },
      ExactMatch: {
        Premium: `${itc}.aftermarket_exact`,
        RegPremium: `${itc}.regpremium_exact`,
        Auction: `${itc}.auction_exact`,
        Taken: `${itc}.unavailable_dbs`,
        PreReg: `${itc}.prereg_exact`,
        SmartExactTLD: `${itc}.smartdefault_exact`,
        Available: `${itc}.primary_exact`,
        Unavailable: `${itc}.other_unavailable_exact`
      },
      Spins: {
        PrimaryOrganic: `${itc}.primary_organicspin`,
        PrimaryPaid: `${itc}.primary_paidspin`,
        PrimaryPremium: `${itc}.primary_premiumspin`,
        PrimaryAi: `${itc}.primary_aispin`,
        AftermarketOrganic: `${itc}.aftermarket_organicspin`,
        AftermarketPaid: `${itc}.aftermarket_paidspin`,
        AftermarketPremium: `${itc}.aftermarket_premiumspin`,
        AftermarketAi: `${itc}.aftermarket_aispin`,
        UnavailableOrganic: `${itc}.unavailable_organicspin`,
        UnavailablePaid: `${itc}.unavailable_paidspin`,
        UnavailablePremium: `${itc}.unavailable_premiumspin`,
        UnavailableAi: `${itc}.unavailable_aispin`,
        SmartdefaultOrganic: `${itc}.smartdefault_organicspin`,
        SmartdefaultPaid: `${itc}.smartdefault_paidspin`,
        SmartdefaultPremium: `${itc}.smartdefault_premiumspin`,
        SmartdefaultAi: `${itc}.smartdefault_aispin`
      }
    }
  })))
};